export default "__VITE_ASSET__SRT3Lfr1__"